export const generateICalFile = (stream: {
  id: string;
  title: string;
  description?: string;
  started_at: string;
  creator_name?: string;
}) => {
  const startDate = new Date(stream.started_at);
  const endDate = new Date(startDate.getTime() + 2 * 60 * 60 * 1000); // 2 hours default duration

  const formatDate = (date: Date) => {
    return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  };

  const icsContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Live Stream Platform//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${stream.id}@livestream.app`,
    `DTSTAMP:${formatDate(new Date())}`,
    `DTSTART:${formatDate(startDate)}`,
    `DTEND:${formatDate(endDate)}`,
    `SUMMARY:${stream.title}`,
    `DESCRIPTION:${stream.description || 'Live stream by ' + (stream.creator_name || 'creator')}`,
    `URL:${window.location.origin}/stream/${stream.id}`,
    'STATUS:CONFIRMED',
    'SEQUENCE:0',
    'BEGIN:VALARM',
    'TRIGGER:-PT30M',
    'ACTION:DISPLAY',
    'DESCRIPTION:Stream starts in 30 minutes',
    'END:VALARM',
    'END:VEVENT',
    'END:VCALENDAR'
  ].join('\r\n');

  return icsContent;
};

export const downloadICalFile = (stream: any) => {
  const icsContent = generateICalFile(stream);
  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `stream-${stream.id}.ics`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

export const getGoogleCalendarUrl = (stream: {
  title: string;
  description?: string;
  started_at: string;
  id: string;
}) => {
  const startDate = new Date(stream.started_at);
  const endDate = new Date(startDate.getTime() + 2 * 60 * 60 * 1000);
  
  const formatGoogleDate = (date: Date) => {
    return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  };

  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: stream.title,
    details: stream.description || 'Live stream event',
    dates: `${formatGoogleDate(startDate)}/${formatGoogleDate(endDate)}`,
    location: `${window.location.origin}/stream/${stream.id}`,
    ctz: Intl.DateTimeFormat().resolvedOptions().timeZone
  });

  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};
